<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useStore } from 'vuex';
import progressBar from "@/primitivesVue3/baseProgressBar/baseProgressBar.vue";

const store = useStore();
const containerNotifications = ref(null);
const timerClose = ref(20000);
let interval = null;

const getListNotifications = computed(() =>
   store.getters["user_notifications/GET_LIST_NOTIFICATIONS"]
);

const setIsVisibleNotPopup = (val) =>
   store.commit("user_notifications/SET_IS_VISIBLE_NOTIFICATIONS_POPUP", val);

const cleanListNotifications = () =>
   store.commit("user_notifications/CLEAN_LIST_NOTIFICATIONS");

const resetTimer = () => {
   timerClose.value = 20000;
};

const download = (link) => {
   window.location.href = link;
};

const closePopup = () => {
   setIsVisibleNotPopup(false);
   setDefaultPositionForAlert();
};

const setDefaultPositionForAlert = () => {
   const globalRestyleAlert = document.querySelector('.restyle-alert');
   if (globalRestyleAlert) {
      globalRestyleAlert.style.bottom = '46px';
   }
};

const cleanBTN = () => {
   cleanListNotifications();
};

const reloadPage = (notification) => {
  const version = notification.params?.version;
  const newUrl = new URL(window.location.href);
  newUrl.searchParams.set('v', version);
  window.location.replace(newUrl);
}

onMounted(() => {
   interval = setInterval(() => {
      if (timerClose.value >= 1000) {
      timerClose.value -= 1000;
      } else {
      setIsVisibleNotPopup(false);
      setDefaultPositionForAlert();
      clearInterval(interval);
      }
   }, 1000);
});

onBeforeUnmount(() => {
   setDefaultPositionForAlert();
   clearInterval(interval);
});
</script>

<template>
   <div class="popup" @click="resetTimer()">
      <div class="popup-container" ref="containerNotifications">
         <div class="popup-header">
            <div v-if="getListNotifications.length" class="popup-header__count">
               {{ getListNotifications.length }}
            </div>
            <div v-else />
            <div style="display: flex; align-items: center;">
               <button v-if="getListNotifications.length" class="popup-header__btn-clean" @click="cleanBTN()">
                  Очистить
               </button>
               <div class="popup-header__close-popup" @click="closePopup()">&times;</div>
            </div>
         </div>
         <div @scroll="resetTimer()" class="popup-content scrollbar scrollbar--primary">
            <div v-if="getListNotifications.length">
               <div class="notification" v-for="(notification) in getListNotifications" :key="notification.id">
                  <div v-if="notification.type === 'test'">
                     <h3 class="notification__title mb-0">
                        {{ notification.message }}!
                     </h3>
                  </div>
                  <div v-if="notification.type === 'processing_file'">
                     <h3 class="notification__title">
                        {{ notification.message }}
                     </h3>
                     <div class="notification__bottom-info">
                        <div class="notification__bottom-info__progress-bar">
                           <progressBar
                              :value="notification?.params.progress"
                              :animated="notification?.params.progress !== 100"
                              :isError="notification?.params?.error"
                           />
                        </div>
                        <button v-if="notification?.params.progress === 100"
                        @click="download(notification.params.link)"
                        class="notification__bottom-info__btn-action">
                           Скачать
                        </button>
                        <div v-else class="notification__bottom-info__percent"
                           :class="{
                              'is-error': notification?.params?.error
                           }">
                           {{ `${notification?.params.progress}%` }}
                        </div>
                     </div>
                     <p v-if="notification?.params?.error" class="notification__error">
                        {{ `Ошибка: ${notification.params.error}`}}
                     </p>
                  </div>
                  <div class="update-notification" v-if="notification.type === 'update'">
                    <h3 class="notification__title update-notification-title">
                      {{ notification.message }}
                    </h3>
                    <button
                      @click="reloadPage(notification)"
                      class="notification__bottom-info__btn-action update-notification-button"
                    >
                      Перезагрузить
                    </button>
                  </div>
               </div>
            </div>
            <div v-else class="empty-notifications">
               Уведомлений нет.
            </div>
         </div>
      </div>
   </div>
</template>

<style lang="scss" scoped>

.popup-container {
   position: fixed;
   top: 52px;
   right: 52px;
   overflow: hidden;
   max-height: 400px;
   width: 425px;
   background-color: #1D407B;
   color: white;
   padding: 10px;
   border: 1px solid $color-link;
   border-radius: 8px;
   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
   z-index: 9999;
}

.popup-content {
   max-height: 380px;
   overflow-y: auto;
   width: 100%;
   padding-bottom: 30px;
}

.popup-header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 10px;
   &__count {
      color: white;
      font-size: 18px;
      font-weight: bold;
   }
   &__btn-clean {
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 90px;
      height: 26px;
      background: transparent;
      border-radius: 50px;
      border: 1px solid #110c61;
      background-color: white;
      font-weight: 700;
      font-size: 14px;
      line-height: 27px;
      color: #110c61;
      transition: all 0.3s ease;
      margin-right: 10px;
      &:hover {
         background-color: #44ff8f;
         color: #110c61;
      }
   }
   &__close-popup {
      cursor: pointer;
      font-size: 20px;
      color: white;
      &:hover {
         font-weight: bold;
      }
   }
}

.notification {
   border: 1px solid black;
   border-radius: 15px;
   padding: 10px;
   margin-bottom: 10px;
   color: #110c61;
   background-color: white;
   &:last-child {
      margin-bottom: 0;
   }
   &__title {
      font-size: 14px;
   }
   &__error {
      color: $color-error;
      margin-bottom: 0;
   }
   &__bottom-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &__progress-bar {
         width: 266px;
         margin: auto 0;
         margin-right: 10px;
         height: 10px;
      }
      &__btn-action {
         padding: 10px 20px;
         position: relative;
         display: inline-flex;
         align-items: center;
         justify-content: center;
         width: 105px;
         height: 28px;
         background: #44ff8f;
         border-radius: 50px;
         cursor: pointer;
         border: 3px solid transparent;
         font-weight: 700;
         font-size: 13px;
         line-height: 27px;
         color: #110c61;
         transition: all 0.3s ease;
         margin-left: auto;
         &:hover {
            background-color: #110c61;
            color: #44ff8f;
         }
      }
      &__percent {
         color: #110c61;
         font-size: 16px;
         font-weight: bold;
         margin-bottom: 3px;
         margin-right: auto;
      }
   }
}
.empty-notifications {
   display: flex;
   align-items: center;
   justify-content: center;
   color: white;
   font-size: 16px;
}

.update-notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-title {
    margin-bottom: unset;
  }
  &-button {
    width: unset;
    padding: 2px;
  }
}

.is-error {
   color: $color-error;
}

</style>

